import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { auth } from '../actions';

import wordmark from '../pinstripe-wordmark.png';

class Signin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
    };
  }
  
  componentDidMount() {
    window.analytics.page("Sign In Viewed");
  }

  handleUsername = e => {
    this.setState({ username: e.target.value });
  }

  handlePassword = e => {
    this.setState({ password: e.target.value });
  }
  
  onSubmit = e => {
    e.preventDefault();
    this.props.login(this.state.username, this.state.password);
    window.analytics.track("Signin", {
      user: this.state.username,
    });
  }

  handleClose = e => {
    this.props.history.push('/apps'); 
  }

  render() {
    let required = true;
    
    if (this.props.isAuthenticated) {
      this.props.history.push('/apps');
    }
    return (
      <div className="auth signin">
        <form onSubmit={this.onSubmit}>
          <Link className="btn_close" to="" onClick={this.handleClose}>
            <i className="fa fa-angle-right"></i>
            <i className="fa fa-angle-left"></i>
          </Link>
          <fieldset>
            <legend>
              <img src={wordmark} className="App-logo" alt="pinstripe wordmark" />
            </legend>
            {this.props.errors.length > 0 && (
              <ul>
                {this.props.errors.map(error => (
                  <li key={error.field}>{error.message}</li>
                ))}
              </ul>
            )}
            <p>
              <label htmlFor="username">Username</label>
              <input
                type="text" id="username" name="username"
                required={required}
                onChange={this.handleUsername} />
            </p>
            <p>
              <label htmlFor="password">Password <a href='' style={{'float': 'right', 'display': 'none'}}>Forgot your password?</a></label>
              <input
                type="password" id="password" name="password"
                required={required}
                onChange={this.handlePassword} />
            </p>
            <p>
              <button className="btn" type="submit">Sign In</button>
            </p>
            <p>
              Don't have an account? <Link className="link" to="/signup">Sign Up</Link>
            </p>
          </fieldset>
        </form>
        <div className="side-img">
          <h1>“The road to success is always under construction.”</h1>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let errors = [];
  if (state.auth.errors) {
    errors = Object.keys(state.auth.errors).map(field => {
      return {field, message: state.auth.errors[field]};
    });
  }
  return {
    errors,
    isAuthenticated: state.auth.isAuthenticated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    login: (username, password) => {
      return dispatch(auth.login(username, password));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Signin);


// WEBPACK FOOTER //
// ./src/components/Signin.js